import { Helpers } from '../../helpers';
import { IApprovalCategory } from '../../interfaces/iapproval-category';
import { DrillGroup } from '../drill-group';

export class ApprovalCategoryBase {
  ApprovalCategoryId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  DrillGroups_ApprovedAs?: Array<DrillGroup> | null;

  constructor(item?: IApprovalCategory) {
    if (item) {

      this.ApprovalCategoryId = item.ApprovalCategoryId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.DrillGroups_ApprovedAs = Helpers.createClassArray(DrillGroup, item.DrillGroups_ApprovedAs);
    }
  }
}